import { fonts } from '@shared/tokens/fonts.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import * as stylex from '@stylexjs/stylex';
import { typography } from '@shared/tokens/typography.stylex';

export const styles = stylex.create({
  textBtn: {
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-1'],
    textAlign: 'left',
  },
  steps: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  excelInput: () => ({
    width: '530px',
    height: '152px',
    padding: '32px 16px 32px 16px',
    gap: '8px',
    borderRadius: '8px 0px 0px 0px',
    border: '1px solid',
    borderColor: colors.tertiaryBorder,
    opacity: '0px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  }),
  excelText: {
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: anatomy['size-12'],
    textAlign: 'left',
    color: colors.tertiaryText,
  },
  withExcelBase: {
    paddingTop: '24px',
    display: 'flex',
    gap: '24px',
    flexDirection: 'column',
  },
  cancelBtn: {
    color: colors.primaryText,
  },
  acceptBtn: {
    color: colors.primaryInverseText,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '24px',
    gap: '16px',
    padding: '16px',
    height: '280px',
    background: colors.ghostBackground,
    borderRadius: anatomy.borderRadiusM,
  },
  inputs: {
    display: 'flex',
    flexDirection: 'column',
    gap: '36px',
    paddingTop: '16px',
    ':not(#__unused__) > div > div': {
      height: '16px',
    },
  },
  stepsText: {
    color: colors.secondaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: '12px',
    textAlign: 'left',
  },
  flex: {
    display: 'flex',
    gap: '16px',
    ':not(#__unused__) > div > div': {
      height: '16px',
    },
  },
  xMarkIcon: {
    fill: colors.secondaryIcon,
    position: 'absolute',
    cursor: 'pointer',
    right: '14px',
    top: '6%',
    transform: 'translateY(-50%)',
  },
  container: {
    position: 'relative',
  },
});
